import OncoreLoader from '@oncore/ui/shared/OncoreLoader';
import { withUntitledUIRenderer } from '../UntitledUIRenderer';
import { StyledLinearProgress } from '@oncore/shared';

export default withUntitledUIRenderer({
  legacy: StyledLinearProgress,
  untitledUI: OncoreLoader
});
